export class ServerUnexpectedError extends Error {
  constructor() {
    super();
  }
}
